// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".perks[data-v-34ab02c4] h2.h1{font-size:2rem;line-height:2.75rem;margin-bottom:0}.perks[data-v-34ab02c4] h3.h4{font-size:1.25rem;margin-bottom:.5rem !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
